export function hexToHSL(hex) {
  if (!hex || typeof hex !== 'string') return null;

  hex = hex.replace('#', '');
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }
  if (hex.length !== 6) return null;

  const r = parseInt(hex.substr(0, 2), 16) / 255;
  const g = parseInt(hex.substr(2, 2), 16) / 255;
  const b = parseInt(hex.substr(4, 2), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
      case g: h = ((b - r) / d + 2); break;
      case b: h = ((r - g) / d + 4); break;
    }
    h *= 60;
  }

  return {
    h: Math.round(h),
    s: Math.round(s * 100),
    l: Math.round(l * 100),
  };
}

export function generateHSLShades(baseHex, prefix = 'clr') {
  const hsl = hexToHSL(baseHex);
  if (!hsl) return {};

  const { h, s, l } = hsl;

  const shades = {
    25: `hsl(${h}, ${s}%, ${Math.min(95, l + 50)}%)`,
    50: `hsl(${h}, ${s}%, ${Math.min(85, l + 40)}%)`,
    100: `hsl(${h}, ${s}%, ${Math.min(75, l + 20)}%)`,
    200: `hsl(${h}, ${s}%, ${Math.min(65, l + 10)}%)`,
    300: `hsl(${h}, ${s}%, ${l}%)`,
    400: `hsl(${h}, ${s}%, ${Math.max(30, l - 10)}%)`,
    600: `hsl(${h}, ${s}%, ${Math.max(20, l - 20)}%)`,
    900: `hsl(${h}, ${s}%, ${Math.max(10, l - 30)}%)`,
  };

  return Object.fromEntries(
    Object.entries(shades).map(([key, val]) => [`--${prefix}-${key}`, val])
  );
}
